import { getUuid, Uuid } from '@sibe/utilities/common';
import type { HsRenderObjects } from './render-objects.class';

export class HsSwapChainObject {
  public readonly uuid: Uuid = getUuid();
  public readonly renderObjects: HsRenderObjects<any, any>[] = [];
}
